// Encoding helpers for hex-encoded byte strings — paired with
// base64url-no-padding conversions because that's the format we use
// for shorter URL-friendly representations of the same bytes.

// HexToBase64URL re-encodes a hex string as base64url with no padding.
// Returns the input unchanged when it isn't valid hex (odd length or
// non-hex characters) so a caller can pipe untrusted strings through
// without try/catching.
const hexPairsRE = /^(?:[0-9a-fA-F]{2})+$/;
export function HexToBase64URL(hex: string): string {
    if (!hex) {
        return '';
    }
    // Validate up front: parseInt(2,16) is too lax (e.g. parseInt('0g',16)
    // returns 0), so a per-pair NaN check would still let partial-garbage
    // strings through silently.
    if (!hexPairsRE.test(hex)) {
        return hex;
    }
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }
    let binary = '';
    for (const b of bytes) {
        binary += String.fromCharCode(b);
    }
    return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}

// Base64URLToHex re-encodes a base64url-no-padding string as lowercase
// hex. Returns "" when the input isn't valid base64.
export function Base64URLToHex(encoded: string): string {
    if (!encoded) {
        return '';
    }
    let b64 = encoded.replaceAll('-', '+').replaceAll('_', '/');
    while (b64.length % 4 !== 0) {
        b64 += '=';
    }
    let binary: string;
    try {
        binary = atob(b64);
    } catch {
        return '';
    }
    let hex = '';
    for (let i = 0; i < binary.length; i++) {
        hex += binary.charCodeAt(i).toString(16).padStart(2, '0');
    }
    return hex;
}
